import { AI_ENDPOINTS } from 'features/ai-generators/constants';
import { SECONDARY_API_CLIENT } from 'services/API';

export const generateRoleplayCall = async data => {
  return SECONDARY_API_CLIENT.post(AI_ENDPOINTS.roleplayCalls, data);
};

export const getRoleplayMetrics = async data => {
  return SECONDARY_API_CLIENT.get(AI_ENDPOINTS.roleplayMetrics, {
    params: data
  });
};
